import React, { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../StudentDashboard/Sidebar";
import Header from "../StudentDashboard/Headers";
import { API_URL } from "../../config/api";
import { Outlet } from "react-router-dom";

const MyPrograms = () => {
  const [userData, setUserData] = useState(null);
  const [courses, setCourses] = useState([]); 
  const [courseCounts, setCourseCounts] = useState({
    total_schedules: 0,
    active_courses: 0,
    completed_courses: 0,
    upcoming_courses: 0
  }); // NEW: Store API counts
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserAndCourses = async () => {
      try {
        const token = localStorage.getItem("access_token");

        if (!token) {
          console.error("No access token found");
          setLoading(false);
          return;
        }

        // Fetch Current User
        const userResponse = await axios.get(`${API_URL}/current_user`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        setUserData(userResponse.data);

        // Fetch User's Enrolled Courses
        const courseResponse = await axios.get(
          `${API_URL}/enroll-course/my-courses`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        // Extract schedules array and counts
        setCourses(courseResponse.data.schedules || []);
        setCourseCounts({
          total_schedules: courseResponse.data.total_schedules || 0,
          active_courses: courseResponse.data.active_courses || 0,
          completed_courses: courseResponse.data.completed_courses || 0,
          upcoming_courses: courseResponse.data.upcoming_courses || 0
        });
        
        console.log("current user enrolled Courses:", courseResponse.data.schedules);
      } catch (error) {
        console.error("Error fetching user or courses:", error);
        setCourses([]);
      } finally {
        setLoading(false);
      }
    };

    fetchUserAndCourses();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#4AACC5] mx-auto"></div>
        </div>
      </div>
    );
  }

  if (!userData) {
    return (
      <div className="flex items-center justify-center min-h-screen text-gray-600">
        Unable to load user data. Please log in again.
      </div>
    );
  }

  return (
    <div className="h-screen overflow-hidden bg-zinc-100 flex flex-col">
      <Header userData={userData} />

      <div className="flex flex-1 overflow-hidden">
        <div className="w-56 bg-white border-r border-neutral-200 flex flex-col">
          <Sidebar />
        </div>

        <div className="flex-1 p-4 overflow-y-auto">
          {/* Pass courses AND courseCounts via context */}
          <Outlet context={{ userData, courses, courseCounts }} />
        </div>
      </div>
    </div>
  );
};

export default MyPrograms;